import Vue from 'vue';
import Router from 'vue-router';
import guestGuard from '../guards/guest';
import userGuard from '../guards/user';
import authGuard from '../guards/auth';
import appData from '../guards/app-data';
import authServices from '../guards/auth-services';
import impersonate from '../guards/impersonate';

// import Home from '../pages/Home';

Vue.use(Router);

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      component: () => import(/* webpackChunkName: "group-home" */ '../pages/Home'),
    },
    {
      path: '/single-sign-in/:token',
      name: 'SingleSignIn',
      component: () => import(/* webpackChunkName: "group-home" */ '../pages/Home'),
      meta: { guards: [impersonate] },
    },
    {
      path: '/welcome',
      name: 'Welcome',
      component: () => import(/* webpackChunkName: "group-auth" */ '../pages/Welcome'),
      meta: { guards: [guestGuard, authServices] },
    },
    {
      path: '/login',
      name: 'Login',
      component: () => import(/* webpackChunkName: "group-auth" */ '../pages/LogIn'),
      meta: { guards: [guestGuard] },
    },
    {
      path: '/reset/:token',
      name: 'ResetPassword',
      component: () => import(/* webpackChunkName: "group-auth" */ '../pages/ResetPassword'),
      meta: { guards: [guestGuard] },
    },
    {
      path: '/signup',
      name: 'SignUp',
      component: () => import(/* webpackChunkName: "group-auth" */ '../pages/SignUp'),
      meta: { guards: [guestGuard] },
    },
    {
      path: '/create-ad',
      name: 'CreateAd',
      component: () => import(/* webpackChunkName: "group-manage-ad" */ '../pages/CreateAd'),
      meta: { guards: [authGuard] },
    },
    {
      path: '/edit-ad/:id',
      name: 'EditAd',
      component: () => import(/* webpackChunkName: "group-manage-ad" */ '../pages/CreateAd'),
      meta: { guards: [authGuard] },
    },
    {
      path: '/sell-faster/:id',
      name: 'FeatureAd',
      component: () => import('../pages/FeatureAd'),
      meta: { guards: [authGuard], mobileHeader: true },
    },
    {
      path: '/congratulations',
      name: 'Congratulations',
      component: () => import('../pages/Congratulations'),
      meta: { guards: [authGuard], mobileHeader: true },
    },
    {
      path: '/search',
      name: 'Search',
      component: () => import('../pages/AdSearch'),
    },
    {
      path: '/profile/:id',
      name: 'Profile',
      component: () => import('../pages/UserProfile'),
    },
    {
      path: '/ad/:id',
      name: 'Ad',
      component: () => import('../pages/Ad'),
    },
    {
      path: '/details',
      component: () => import(/* webpackChunkName: "group-info" */ '../pages/Details'),
      name: 'Details',
      children: [
        { path: '', redirect: 'about' },
        {
          path: 'about',
          name: 'About',
          component: () => import(/* webpackChunkName: "group-info" */ '../pages/About'),
        },
        {
          path: 'getting-started',
          name: 'GettingStarted',
          component: () => import(/* webpackChunkName: "group-info" */ '../pages/GettingStarted'),
        },
        {
          path: 'trust-and-use',
          name: 'Terms of use',
          component: () => import(/* webpackChunkName: "group-info" */ '../pages/TermsOfUse'),
        },
        {
          path: 'trust-and-safety',
          name: 'Trust and Safety',
          component: () => import(/* webpackChunkName: "group-info" */ '../pages/TrustAndSafety'),
        },
        {
          path: 'privacy-policy',
          name: 'Privacy policy',
          component: () => import(/* webpackChunkName: "group-info" */ '../pages/PrivacyPolicy'),
        },
        {
          path: 'terms-and-conditions',
          name: 'Terms and Conditions',
          component: () => import(/* webpackChunkName: "group-info" */ '../pages/TermsAndConditions'),
        },
        {
          path: 'contact',
          name: 'Contact',
          component: () => import(/* webpackChunkName: "group-info" */ '../pages/Contact'),
        },
      ],
    },
    {
      path: '/account-settings',
      component: () => import(/* webpackChunkName: "group-settings" */ '../pages/AccountSettings'),
      meta: { guards: [authGuard] },
      children: [
        { path: '', redirect: 'my-profile' },
        {
          path: 'my-profile',
          name: 'MyProfile',
          component: () => import(/* webpackChunkName: "group-settings" */ '../pages/AccountSettings/MyProfile'),
          meta: { guards: [authGuard] },
        },
        {
          path: 'messages/:tab?/:userId?/:adId?',
          name: 'Messages',
          component: () => import(/* webpackChunkName: "group-settings" */ '../pages/AccountSettings/Messages'),
          meta: { guards: [authGuard] },
          children: [{
            path: 'user-message',
            name: 'UserMessage',
            component: () => import(/* webpackChunkName: "group-settings" */ '../pages/UserMessage'),
          }],
        },
        {
          path: 'favorites',
          name: 'Favorites',
          component: () => import(/* webpackChunkName: "group-settings" */ '../pages/AccountSettings/Favorites'),
          meta: { guards: [authGuard] },
        },
        {
          path: 'my-ads',
          name: 'MyAds',
          component: () => import(/* webpackChunkName: "group-settings" */ '../pages/AccountSettings/MyAds'),
          meta: { guards: [authGuard] },
        },
      ],
    },
    {
      path: '*',
      component: () => import(/* webpackChunkName: "group-not-found" */ '../pages/PageNotFound'),
    },
    {
      path: 'not-found',
      component: () => import(/* webpackChunkName: "group-not-found" */ '../pages/PageNotFound'),
    },
  ],
  defaultGuards: [userGuard, appData],
  defaultRoute: '/',
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js